import { RequestQuery } from '@/data/types/RequestQuery';
import { RequestParams } from 'integration/generated/transactions/http-client';
import { transactionsClubdp, transactionsMonederoElectronico } from 'integration/generated/transactions';
import { useSettings, useSingleSettings } from '@/data/Settings';
import { getClientSideCommon } from '@/data/utils/getClientSideCommon';
import { useNextRouter } from '@/data/Content/_NextRouter';
import { useExtraRequestParameters } from '@/data/Content/_ExtraRequestParameters';
import useSWR from 'swr';
import { useCallback, useMemo } from 'react';
import { useNotifications } from '@/data/Content/Notifications';
import { TransactionErrorResponse } from '@/data/types/Basic';
import { processError } from '@/data/utils/processError';
import { useIsOpen } from 'integration/hooks/useIsOpen';
import getValueByPathFromUnknown from 'integration/utils/getValueByPathFromUnknown';
import valueIsString from 'integration/utils/typeAssertions/valueIsString';
import { useUser } from '@/data/User';

const monederoElectronicoFetcher =
	(pub: boolean) =>
	async (storeId: string, query: RequestQuery = {}, params: RequestParams) => {
		const res = await transactionsMonederoElectronico(pub).monederoElectronicoDp(storeId, query, params);
		return res;
	};

const getToCheckString = (data: unknown, path: string[]) => {
	const value = getValueByPathFromUnknown(data, path);

	if (valueIsString(value)) {
		return value;
	}

	return undefined;
};

export const useMonedero = (args?: {
    keepPreviousData?: boolean;
    revalidateOnMount?: boolean;
}) => {
    const { settings } = useSingleSettings();
    const router = useNextRouter();
    const { storeId } = getClientSideCommon(useSettings().settings, router);
    const userData = settings?.userData || {};
    const baseSettings = useMemo(() => {
        const monederoActivo = getToCheckString(userData, ['active_monederoDpt']) || null;
        return {
            monederoActivo
        };
    }, [settings?.userData]);
    const params = useExtraRequestParameters();
    const { notifyError } = useNotifications();
    const { user } = useUser();
    console.log(baseSettings);
    const userId = user?.userId;
    if(baseSettings.monederoActivo === null || baseSettings.monederoActivo === 'false'){
        return {
            valesDeCaja: null,
        };
    }

    const {
        data,
        error,
        isLoading,
    } = useSWR(
        storeId && userId
                    ? [{ storeId, userId}]
                    : null,

        async ([{ storeId }]) => monederoElectronicoFetcher(true)(storeId, {}, params),
        {
            keepPreviousData: args?.keepPreviousData ?? true,
            revalidateOnMount: args?.revalidateOnMount ?? false,
        }
    );

    return {
        valesDeCaja: data,
        error,
        loading: isLoading,
    };
};
